import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from 'inversify';
import { CustomFieldSortType } from '../enums';
function getInitialState() {
    return {
        fields: [],
        currentSort: CustomFieldSortType.EARLY_CREATED,
        counts: {
            customFieldCount: 0,
            publicCustomFieldCount: 0,
        },
    };
}
let CustomFieldsModelImpl = class CustomFieldsModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = getInitialState();
    }
    dispose() {
        this.update(getInitialState);
    }
};
CustomFieldsModelImpl = __decorate([
    injectable()
], CustomFieldsModelImpl);
export { CustomFieldsModelImpl };
